import styled from 'styled-components'
import { deviceDF } from 'assets/breakPoints'
export const MainHeading = styled.h1`
   text-align: center;
   margin: 20px;
`

export const Image = styled.img`
   width: 100vw;
   height: auto;
   object-fit: cover;
   max-height: 70vh;
   @media ${deviceDF.desktop} {
      height: 760px;
   }
   @media ${deviceDF.laptopL} {
      height: 600px;
   }
   
   @media ${deviceDF.mobileM} {
      height: 190px;
   }
   @media ${deviceDF.mobileL} {
      height: 200px;
   }
   

`
export const Container = styled.section`
   width: 100vw;
   height: auto;
   display: flex;
   flex-direction: column;
   gap: 10px;
   overflow: hidden;
`
export const SectionForm = styled.form`
   display: flex;
   margin: 0px 80px;
   gap: 20px;
   @media ${deviceDF.mobileM} {
      flex-direction: column;
      margin: 10px;
   }
   @media ${deviceDF.mobileL} {
      flex-direction: column;
      margin: 12px;
   }
   @media ${deviceDF.tablet} {
      flex-direction: column;
      margin: 18px;
   }
`

export const ButtonWrapper = styled.div`
   display: flex;
   justify-content: space-between;
   margin: 0px 80px;
   gap: 20px;
   padding: 0 30px;
   flex-direction: row-reverse;
   @media ${deviceDF.mobileL} {
      margin: 0;
      flex-direction: column;
   }
`
export const HelpText = styled.p`
   font-family: 'Courier New', Courier, monospace;
   font-size: 18px;
`

export const InfoText = styled.div`
   font-family: "Red Hat Display", Sans-serif !important;
   font-size: 15px;
   text-align: center;
   padding: 5px 120px;
   margin: 40px 50px;
   @media ${deviceDF.tablet} {
      margin: auto;
   }
   @media ${deviceDF.mobileL} {
      margin: 20px auto;
      padding: 5px 50px;
   }
   @media ${deviceDF.mobileM} {
      margin: auto;
      padding: 5px 50px;
   }
   @media ${deviceDF.mobileS} {
      margin: auto;
      padding: 5px 50px;
   }
   
   
   
   `

export const InfoHeading = styled.h3`
   text-align: center;
`

export const InfoHeadingCheck = styled.h4`
   text-align: center;
`

export const Footer = styled.footer`
   background-color: #353535;
   width: 100vw;
   height: 90px;
   display: flex;
   flex-direction: column;
   align-items: center;
   padding: 5px 0px;

   p {
      font-size: 17px;
      color: #fff;
      //margin-top: 20px;
   }
   span {
      font-size: 11px;
      color: #fff;
   }
   @media ${deviceDF.laptopL} {
      height: 100px;
   }
`

export const ImgGlobalBlur = styled.img`
  @media ${deviceDF.mobileL} {
    width: 300px;
    height: 900px;
  }
  @media ${deviceDF.mobileM} {
    width: 300px;
    height: 900px;
  }   
  
`